// NOTE: This service has been stubbed out because the Django backend it originally
// called (/api/users/api-tokens/) no longer exists in the Firebase-native architecture.
// The API Tokens settings page will silently show no tokens rather than throwing
// network errors. Implement this against Firestore when the feature is needed.

import type { IApiToken } from "@buzzwaretech/types";

export class APITokenService {
  async list(): Promise<IApiToken[]> {
    return [];
  }

  async retrieve(_tokenId: string): Promise<IApiToken> {
    return Promise.reject(new Error("API Tokens are not yet implemented."));
  }

  async create(_data: Partial<IApiToken>): Promise<IApiToken> {
    return Promise.reject(new Error("API Tokens are not yet implemented."));
  }

  async destroy(_tokenId: string): Promise<void> {
    return;
  }
}
